import { useMutation } from "@apollo/client/react";

import {
  mutationDocuments,
  queryDocuments,
} from "@smart/manage-gql-operations-dom";

import { useQueryFactory } from "./base";

export const useLoadFormVersions = useQueryFactory(
  queryDocuments.formVersions,
  {
    map: ({ formVersions }) => formVersions.map((v) => v.values),
  },
);

export const useApplyFormVersion = () =>
  useMutation(mutationDocuments.applyFormVersion);
